import * as Yup from 'yup'

import { PRESET_COLORS } from '../../components/forms/fields/ColorPickerController'

export const productSchema = Yup.object().shape({
  name: Yup.string().required().max(255),
  lessonType: Yup.string().required().oneOf(['private', 'group']),
  durationMinutes: Yup.number().required().min(30).integer(),
  price: Yup.number().required().min(0),
  pricePerAdditionalPerson: Yup.number()
    .nullable()
    .min(0)
    .when('lessonType', {
      is: 'private',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.default(null),
    }),
  vatRate: Yup.number().required().min(0).max(100),
  color: Yup.string()
    .required()
    .oneOf([...PRESET_COLORS]),
  isActive: Yup.boolean().required(),
})

export const useSchema = () => productSchema

export type ProductFormValues = Yup.InferType<typeof productSchema>
